// frontend/src/pages/PVDettaglio.jsx
import React, { useEffect, useState } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import { authFetch } from "../utils/authFetch";

const API_URL = process.env.REACT_APP_API_URL || "";

const Row = ({ label, value }) => (
  <p><strong>{label}:</strong> {value || "—"}</p>
);

const PVDettaglio = () => {
  const { id } = useParams();
  const [pv, setPv] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const goBack = () => {
    // se non c'è history reale, vai alla lista Punti Vendita
    if (window.history.length > 1) navigate(-1);
    else navigate("/pv");
  };

  const load = async () => {
    setLoading(true);
    try {
      const res = await authFetch(`${API_URL}/api/pv/${id}/`);
      const json = await res.json();
      setPv(json);
    } catch (e) {
      console.error(e);
      setPv(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  // ESC per tornare indietro
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") goBack();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (loading) return <div className="container mt-4"><p>Caricamento…</p></div>;
  if (!pv) return <div className="container mt-4"><div className="alert alert-danger">Punto Vendita non trovato.</div></div>;

  return (
    <div className="container mt-4">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="m-0">🏪 {pv.name} <small className="text-muted">({pv.code})</small></h3>
        <div className="d-flex gap-2">
          <button className="btn btn-outline-secondary" onClick={goBack} title="Torna indietro (Esc)">
            ← Indietro
          </button>
          <Link to={`/pv/${id}/edit`} className="btn btn-primary">Modifica</Link>
        </div>
      </div>

      <div className="row g-3">
        <div className="col-md-6">
          <div className="card p-3 h-100">
            <h5>Dati principali</h5>
            <Row label="Referente" value={pv.referent} />
            <Row label="Indirizzo" value={pv.address} />
            <Row label="Telefono" value={pv.telefono} />
            <Row label="Email fatturazione" value={pv.fatt_email} />
            <Row label="P.IVA" value={pv.fatt_piva} />
          </div>
        </div>

        <div className="col-md-6">
          <div className="card p-3 h-100">
            <h5>Account</h5>
            <Row label="Username" value={pv.username} />
            <Row label="Email" value={pv.email} />
            <hr />
            <h5>Statistiche</h5>
            <Row label="Agenti" value={pv.num_agenti ?? 0} />
            <Row label="Clienti" value={pv.num_clienti ?? 0} />
            <Row label="Ordini" value={pv.num_ordini ?? 0} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PVDettaglio;
